import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { useSession } from '../../lib/authClient.js';

function partOfDay(hour: number): string {
  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';
  return 'Good evening';
}

// The signed-in user's first name, from their session; no name, no comma.
export function DashboardGreeting({ now = new Date() }: { now?: Date }): ReactNode {
  const { data: session } = useSession();
  const first = (session?.user.name ?? '').trim().split(/\s+/)[0] ?? '';
  return (
    <Typography
      component="h1"
      data-testid="dashboard-greeting"
      sx={{ fontSize: 24, fontWeight: 500, lineHeight: '30px', color: 'background.icon' }}
    >
      {first === '' ? partOfDay(now.getHours()) : `${partOfDay(now.getHours())}, ${first}`}
    </Typography>
  );
}
